import { motion } from "framer-motion";
import "../../css/nnat/nnatExamples.css";

const keyAreas = [
  {
    title: "Pattern Completion",
    description: "Identifies the missing portion of a visual pattern.",
    questions: [
      {
        q: "Look at the pattern in the top row. Which shape in the bottom row completes the pattern?",
        correct: "C",
        explanation: "The pattern shows a sequence where each shape rotates 90 degrees clockwise. Option C completes this pattern correctly.",
        image: "/COGAT/NON-VERBAL Paper Folding/image31.png"
      }
    ],
  },
  {
    title: "Reasoning by Analogy",
    description: "Recognizes relationships between shapes and completes the analogy.",
    questions: [
      {
        q: "Look at the shapes in the top row. They follow a specific relationship. Which shape in the bottom row best completes the analogy?",
        correct: "B",
        explanation: "The relationship shows that the outer shape contains the inner shape rotated. Option B maintains this same relationship pattern.",
        image: "/COGAT/NON-VERBAL Figure Classification/image26.png"
      }
    ],
  },
  {
    title: "Serial Reasoning",
    description: "Identifies patterns and selects the next shape in a sequence.",
    questions: [
      {
        q: "Observe the sequence of shapes. They follow a specific pattern. Which shape in the bottom row continues the sequence?",
        correct: "A",
        explanation: "The sequence shows shapes increasing in complexity and rotating. Option A continues this pattern correctly.",
        image: "/COGAT/NON-VERBAL Figure Matrices/image3.png"
      }
    ],
  },
  {
    title: "Spatial Visualization",
    description: "Mentally manipulates shapes to determine how they fit together.",
    questions: [
      {
        q: "Look at the shapes in the boxes. They show how shapes can be rotated and combined. Which shape in the bottom row shows the correct combination?",
        correct: "D",
        explanation: "The shapes demonstrate spatial relationships and rotations. Option D correctly shows how the shapes fit together when rotated.",
        image: "/COGAT/QUANTITATIVE Number Analogies/image11.png"
      }
    ],
  }
];

export default function NnatExamples() {
  return (
    <section className="nnat-examples-section" aria-label="NNAT Sample Questions">
      <div className="nnat-examples-container">
        <h2 className="nnat-examples-title">
          NNAT Sample Questions & Practice Examples
        </h2>
        <p className="nnat-examples-subtitle">
          Practice with real NNAT sample questions from all four key areas. Each example includes detailed explanations to help students understand the reasoning behind the correct answers.
        </p>

        {/* Sample Questions by Area */}
        <div className="nnat-examples-grid">
          {keyAreas.map((area, index) => (
            <motion.article
              key={index}
              initial={{ opacity: 0, y: 20 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.5, delay: index * 0.1 }}
              className="nnat-example-card"
            >
              <h3 className="nnat-example-card-title">{area.title}</h3>
              <p className="nnat-example-card-description">{area.description}</p>

              {/* Sample Questions */}
              <div className="nnat-example-questions">
                {area.questions.map((item, qIndex) => (
                  <div key={qIndex} className="nnat-example-question-box">
                    <h4 className="nnat-example-question-text">{item.q}</h4>

                    {/* Display Image if available */}
                    {item.image && (
                      <div className="nnat-example-image-container">
                        <img 
                          src={`https://k12questionimages.s3.us-east-1.amazonaws.com${item.image}`} 
                          alt={`NNAT sample question: ${area.title}`} 
                          className="nnat-example-image" 
                          loading="lazy"
                        />
                      </div>
                    )}

                    {/* Answer and Explanation */}
                    <div className="nnat-example-answer-section">
                      <div className="nnat-answer-badge">
                        <span className="answer-label">Correct Answer:</span>
                        <span className="answer-value">{item.correct.toUpperCase()}</span>
                      </div>
                      <div className="nnat-explanation-box">
                        <strong className="explanation-label">Explanation:</strong>
                        <p className="explanation-text">{item.explanation}</p>
                      </div>
                    </div>
                  </div>
                ))}
              </div>
            </motion.article>
          ))}
        </div>
      </div>
    </section>
  );
}
